module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container-fluid bg-darker dark"
  }, [_c('div', {
    staticClass: "col-sm-12 py-3 d-flex align-items-center"
  }, [_c('i', {
    staticClass: "ico-search fs-giant"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.title),
      expression: "filters.title"
    }],
    staticClass: "searchTitle dark fs-giant flex-grow",
    attrs: {
      "type": "text",
      "placeholder": "Search by activity title"
    },
    domProps: {
      "value": (_vm.filters.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.categories.length > 0) ? _c('div', {
    staticClass: "col-sm-12 py-2 d-flex justify-content-center bg-lighter flex-wrap"
  }, [_c('button', {
    staticClass: "categoryBtn btn tertiary fs-large border-medium mx-2 dark my-2",
    class: {
      'selected': _vm.selectedCategoryId == null
    },
    on: {
      "click": _vm.seeAllCategories
    }
  }, [_vm._v("See all")]), _vm._v(" "), _vm._l((_vm.categoriesWithQuantity), function(category) {
    return (category.productQauntity > 0) ? _c('button', {
      staticClass: "categoryBtn btn tertiary fs-large border-medium mx-2 dark my-2 position-relative",
      class: {
        'selected': category.id == _vm.selectedCategoryId
      },
      on: {
        "click": function($event) {
          return _vm.selectCategory(category)
        }
      }
    }, [_c('span', {
      staticClass: "productQauntityIndicator fs-smaller radius-stadium px-2"
    }, [_vm._v(_vm._s(category.productQauntity))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(category.name))])]) : _vm._e()
  })], 2) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-1dc669ea", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dc669ea"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/NewReservation/Search/FilterArea.vue
// module id = 2834
// module chunks = 0